
import { Typography } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { AlertModel } from "../Internalcomponents/AlertModel";

export const PieChart = ({ pieData, error, downloadUnitStatusData }) => {
    const [data, setData] = useState([0, 0, 0]);
    const [chartKey, setChartKey] = useState(0);


    const downloadData = (legendIndex) => {

        if (legendIndex === 0) {
            downloadUnitStatusData("get_success_data_url");
        }
        if (legendIndex === 1) {
            downloadUnitStatusData("get_failed_data_url");
        }
    }

    const options = {
        title: {
            // text: 'Units Status'
        },
        chart: {
            events: {
                legendClick: function (event, chartContext, opts) {
                    // The last parameter opts contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                    downloadData(chartContext)
                }
            }
        },

        labels: ['Success', 'Failed', 'No Data'],
        dataLabels: {
            enabled: false
        },
        fill: {
            type: 'gradient',
        },
        legend: {
            position: 'bottom',
            formatter: function (seriesName, opts) {
                return seriesName + " - " + opts.w.globals.series[opts.seriesIndex]
            },

        },
        colors: ["#4318FF", '#ff8a31', '#cad7ea'],
        // colors: ["#4318FF", '#6AD2FF', '#cad7ea'],

    }

    useEffect(() => {
        console.log("  pie data ....")
        console.log(pieData)
        if (Array.isArray(pieData) && pieData.length === 3) {
            setData(pieData);
            setChartKey(prevKey => prevKey + 1);
        }
    }, [pieData]);



    return (
        <>

            {error ? <AlertModel message="error" /> :
                data.some(value => value > 0) && (<ReactApexChart key={chartKey} style={{ marginTop: "auto", marginBottom: "auto" }}
                    options={options} series={pieData} type="pie" />)}



        </>

    );

}